import { render } from "./SendRecipe.vue?vue&type=template&id=2fe6fa0a&scoped=true"
import script from "./SendRecipe.vue?vue&type=script&lang=js"
export * from "./SendRecipe.vue?vue&type=script&lang=js"

import "./SendRecipe.vue?vue&type=style&index=0&id=2fe6fa0a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe6fa0a"]])

export default __exports__